import { useNavigate } from 'react-router';

import { useCustomerDispatch } from '@jane/monolith/customer/redux';
import { handleInvalidLoginToken } from '@jane/monolith/customer/redux/customer';
import { useCheckAuthTimer, useJWT } from '@jane/shared/auth';

export const CheckAuthTimer = () => {
  const bearerToken = useJWT();
  const navigate = useNavigate();
  const dispatch = useCustomerDispatch();
  useCheckAuthTimer(bearerToken, () =>
    dispatch(handleInvalidLoginToken(false, navigate))
  );

  return null;
};
